import clsx from 'clsx'
import { useRouter } from 'next/router'
import InfiniteScroll from 'react-infinite-scroll-component'

import Header from 'app/ProfileRevampPage/components/SectionKarya/PerangkatAjar/Header'
import { EmptyState } from 'app/ProfileRevampPage/components/EmptyState'
import { LoadingState } from 'app/ProfileRevampPage/components/LoadingState'
import ToolkitCard from 'app/ProfileRevampPage/components/SectionKarya/PerangkatAjar/ToolkitCard'
import { DesktopPageHeader, PageContainer } from 'components/ResponsiveLayout'
import { getCategoryTitle } from 'app/ProfileRevampPage/utils/perangkatAjar'
import { usePerangkatAjar } from 'app/ProfileRevampPage/hooks/usePerangkatAjar'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'
import { useProfileDesktopView } from 'app/ProfileRevampPage/hooks/useProfileDesktopView'
import { useSETrackEventToolkits } from 'app/ProfileRevampPage/hooks/useSETrackEventToolkits'

const PerangkatAjarCategoryIndex = () => {
  const { query } = useRouter()
  const { id: profileId } = query
  const category = query?.category as string
  const { isCurrentUser } = useProfile()
  const { isDesktop } = useProfileDesktopView()
  const categoryTitle = getCategoryTitle(category)

  const {
    data: perangkatAjarList,
    meta: perangkatAjarMeta,
    fetchNextPage,
    hasNextPage,
    isLoading,
  } = usePerangkatAjar(profileId as string, category as string)
  const hasPerangkatAjarList = (perangkatAjarList ?? []).length > 0

  const { SETrackClickToolkitItem } = useSETrackEventToolkits()

  const onClickItem = (index, id) => {
    SETrackClickToolkitItem({
      toolkitType: category,
      toolkitLocation: index + 1,
      toolkitId: id,
      numTypeToolkit: perangkatAjarMeta?.[0]?.total ?? 0,
    })
  }

  const content = (
    <>
      {isLoading && <LoadingState />}

      {!isLoading && hasPerangkatAjarList && (
        <InfiniteScroll
          className="lg:!overflow-visible"
          dataLength={perangkatAjarList.length}
          next={fetchNextPage}
          hasMore={hasNextPage}
          loader={<LoadingState />}
        >
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            {perangkatAjarList.map((toolkit, index) => (
              <ToolkitCard
                key={toolkit?.id}
                data={toolkit}
                onClick={() => onClickItem(index, toolkit?.id)}
              />
            ))}
          </div>
        </InfiniteScroll>
      )}

      {!isLoading && !hasPerangkatAjarList && (
        <div className="mt-20 px-3 lg:mt-0 lg:rounded-xl lg:bg-white lg:p-8">
          <EmptyState
            title="Belum ada Perangkat Ajar"
            description={`Kalau Anda mengunggah ${categoryTitle}, nanti akan muncul di sini.`}
          />
        </div>
      )}
    </>
  )

  if (isDesktop) {
    return (
      <div className="min-h-screen bg-surface-neutral-subdued">
        <DesktopPageHeader
          breadcrumbItems={[
            {
              label: isCurrentUser ? 'Profil Saya' : 'Profil Rekan GTK',
              href: `/profil/${profileId}`,
            },
            { label: 'Perangkat Ajar', href: null },
          ]}
        />
        <main>
          <PageContainer className="!py-6">
            <div className="mb-5">
              <h1 className="text-2xl font-semibold text-default">
                {categoryTitle}
              </h1>
            </div>
            {content}
          </PageContainer>
        </main>
      </div>
    )
  }

  return (
    <main
      className={clsx(
        'relative flex flex-col min-h-screen max-w-xl mx-auto',
        hasPerangkatAjarList && 'bg-surface-subdued'
      )}
    >
      <Header />
      <div className="pt-20 pb-4 px-4">{content}</div>
    </main>
  )
}

export default PerangkatAjarCategoryIndex
